import { render, staticRenderFns } from "./GameWx3V1.vue?vue&type=template&id=0abce81a&scoped=true&"
import script from "./GameWx3V1.vue?vue&type=script&lang=js&"
export * from "./GameWx3V1.vue?vue&type=script&lang=js&"
import style0 from "./GameWx3V1.vue?vue&type=style&index=0&lang=css&"
import style1 from "./GameWx3V1.vue?vue&type=style&index=1&lang=css&"
import style2 from "./GameWx3V1.vue?vue&type=style&index=2&id=0abce81a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abce81a",
  null
  
)

export default component.exports